import { render, staticRenderFns } from "./MultiSelectorMetodoPagamento.vue?vue&type=template&id=54343420"
import script from "./MultiSelectorMetodoPagamento.vue?vue&type=script&lang=js"
export * from "./MultiSelectorMetodoPagamento.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./MultiSelectorMetodoPagamento.vue?vue&type=style&index=2&id=54343420&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports